import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function WishlistPage() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/wishlist").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="wishlist-page" className="max-w-7xl mx-auto px-4 sm:px-8 mt-10">
      <h1 className="font-heading text-3xl font-bold tracking-tight">Wishlist</h1>
      {!items ? (
        <div className="h-64 mt-8 rounded-2xl bg-slate-100 animate-pulse" />
      ) : !items.length ? (
        <div data-testid="wishlist-empty" className="mt-10 rounded-2xl bg-slate-50 py-20 text-center">
          <p className="font-heading text-xl font-bold">Nothing saved yet</p>
          <Button asChild className="mt-6 rounded-full bg-slate-900"><Link to="/search" data-testid="wishlist-shop-btn">Discover products</Link></Button>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
